export default "/images/bd1fa8db24826d0d9b7cc49f24bc52cd.avif";